import { useImmerAtom } from 'jotai-immer';
import { useHistory } from 'react-router-dom';

import { automationWizardStateAtom } from './initial-state';
import type { AutomationWizardStep } from './types';

export function useEditAutomation() {
  const history = useHistory();
  const [, setState] = useImmerAtom(automationWizardStateAtom);

  return (automationId: string, page?: AutomationWizardStep) => {
    setState(draft => {
      draft.step = { current: 0, highestVisited: 4 };
      draft.step.current = page ?? 0;
    });
    history.push(`/settings/automations/${automationId}/edit`);
  };
}
